import {User} from './User';

export class AugmentedUserDetails {
activeDomain: string;
internalUser: User;
}

